import React from "react";
import styled from "styled-components";
import icons from "components/images";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import get from "lodash/get";
import HiddenOn from "components/common/HiddenOn";
import DashboardIcon from "@material-ui/icons/Dashboard";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import ExitToAppIcon from "@material-ui/icons/ExitToAppOutlined";
import LiveHelpIcon from "@material-ui/icons/LiveHelpOutlined";
import PostAddIcon from "@material-ui/icons/PostAdd";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import DeveloperBoardIcon from "@material-ui/icons/DeveloperBoard";

const Header = ({ signedIn, isMobile }) => (
  <StyledContainer isMobile={isMobile}>
    <Link to={`/`}>
      <img alt={"SidebarError"} src={icons["CaLogo"]} />
    </Link>
    <div>
      <StyledLink>
        <Link to={`/`}>
          <DashboardIcon />
          Home
        </Link>
      </StyledLink>
      <StyledLink>
        <Link to={`/events`}>
          <DateRangeOutlinedIcon />
          All Events
        </Link>
      </StyledLink>
      <HiddenOn hideOn={!signedIn}>
        <StyledLink>
          <Link to={`/create/new`}>
            <PostAddIcon />
            Create Event
          </Link>
        </StyledLink>
        <StyledLink>
          <Link to={`/myevents`}>
            <DeveloperBoardIcon />
            My Events
          </Link>
        </StyledLink>
      </HiddenOn>
      <StyledLink>
        <Link to={`/faq`}>
          <LiveHelpIcon />
          FAQ
        </Link>
      </StyledLink>
      <HiddenOn
        fallback={
          <StyledLink>
            <Link to={`/login`}>
              <LockOpenIcon />
              Login
            </Link>
          </StyledLink>
        }
        hideOn={!signedIn}
      >
        <StyledLink>
          <Link to={`/logout`}>
            <ExitToAppIcon />
            Logout
          </Link>
        </StyledLink>
      </HiddenOn>
    </div>
  </StyledContainer>
);

const StyledContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => (!!props.isMobile ? "column" : "row")};
  height: ${(props) => (!!props.isMobile ? "unset" : "100px")};
  align-items: ${(props) => (!!props.isMobile ? "center" : "unset")};
  padding: 10px;
  justify-content: space-between;
  img {
    width: 200px;
    border-radius: 5px;
  }
  > div {
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
    place-content: center;
  }
`;

const StyledLink = styled.div`
  display: flex;
  align-items: center;
  min-width: 125px;
  border-style: solid;
  border-color: #3b618ccc;
  border-radius: 8px;
  background-color: #36393f;
  border-width: 2px;
  height: 40px;
  margin: 10px;
  > a {
    > svg {
      padding: 5px;
    }
    display: flex;
    align-items: center;
    padding-right: 5px;
    text-decoration: none;
    color: white;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    font-weight: bolder;
    text-decoration: underline;
  }
`;

const mapStateToProps = (state) => ({
  signedIn: get(state, "rootReducer.core.user.signedIn"),
  isMobile: get(state, "rootReducer.core.isMobile", false),
});

export default connect(mapStateToProps, null)(Header);
